import React, { useState } from 'react';
import { Dialog } from '@tencent/spaui';
import FileUpload from 'pages/regist/components/FileUpload';
import useAgencyDetail from '../../use-agency-detail';

let nextStep: any;

// eslint-disable-next-line react/display-name
export default () => {
  const [show, setShow] = useState(false);
  const { data, onUpdate } = useAgencyDetail();
  const handleAuthorizeFileChange = async (file_url: string, file_name: string) => {
    const isSuccess = await onUpdate({ authorize_file: [{ file_url, file_name }] });
    if (isSuccess) {
      // message.success('操作成功');
    }
  };

  const check = (fileInfo: any, next: () => {}) => {
    setShow(true);
    nextStep = next;
  };

  // if (data.authorize_file) {
  //   return null;
  // }

  return (
    <div style={{ display: 'inline-block' }}>
      <div style={{ padding: '8px 0 4px' }}>开户账号使用授权书：</div>
      <FileUpload
        data={data.authorize_file?.[0]}
        reupload={true}
        uploadText={'上传授权书'}
        check={check}
        onDelete={() => {}}
        onChange={(file_url, file_name: string) => {
          handleAuthorizeFileChange(file_url, file_name);
        }}
      />
      <span style={{ verticalAlign: 'text-bottom', padding: '0 10px' }}>
        下载模板
        <a
          target="_blank"
          href="https://docs.qq.com/doc/DWXhsWG9RaEJtY2FW"
          style={{ color: '#0061e7' }}
          rel="noreferrer"
        >
          【ISV模版】QQ微信注册使用授权书-模版
        </a>
      </span>

      <Dialog
        moveable
        type="normal"
        show={show}
        onClose={() => setShow(false)}
        onSubmit={() => {
          setShow(false);
          nextStep?.();
        }}
        onCancel={() => setShow(false)}
        title="确认"
        style={{
          width: '600px',
        }}
      >
        <div>确认上传授权书</div>
      </Dialog>
    </div>
  );
};
